import React from 'react';
import { TextField, IconButton, Box, Tooltip, InputAdornment, Typography,  useTheme } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';

const CommonSearchField = ({
    placeholder,
    variant,
    size,
    inputProps = {},
    autoFocus,
    startAdornment,
    endAdornment,
    fullWidth,
    value,
    tooltipList = [], // Accept tooltip list as a prop
    ...props
}) => {
    const theme = useTheme();
    const [searchTerm, setSearchTerm] = React.useState(value || "");
    const [timer, setTimer] = React.useState(0);
    const WAIT_INTERVAL = 500;

    const handleClear = () => {
        setSearchTerm("");
        props.handleSearch && props.handleSearch("");
    };

    return (
        <Box display="flex" alignItems="center">
            <Tooltip
                title={
                    tooltipList.length > 0 ? (
                        <Box>
                            <Typography variant="caption" gutterBottom>
                                You can search by :
                            </Typography>
                            <ul style={{ display: 'flex', flexWrap: 'wrap', paddingLeft: 20, margin: 0 }}>
                                {tooltipList?.map((item, index) => (
                                    <li key={index} style={{ width: '60%', }}>
                                        <Typography variant="caption">{item}</Typography>
                                    </li>
                                ))}
                            </ul>
                        </Box>
                    ) : (
                        "Enter search term"
                    )
                }
                arrow
            >
                <TextField
                    onChange={(ev) => {
                        setSearchTerm(ev.target.value);
                        const val = (ev.target.value || "").trim();
                        clearTimeout(timer);
                        setTimer(
                            setTimeout(() => {
                                props.handleSearch && props.handleSearch(val);
                            }, WAIT_INTERVAL)
                        );
                    }}
                    autoFocus={autoFocus}
                    value={searchTerm}
                    size={size || "small"}
                    type="text"
                    inputProps={{ maxLength: 50, ...inputProps }}
                    placeholder={placeholder || "Search"}
                    InputProps={{
                        startAdornment: startAdornment ? (
                            startAdornment
                        ) : (
                            <>
                                {/* <InputAdornment position="start">
                                    <img src={"images/SearchIcon.svg"} width="20px" height="20px" alt="Search Icon" />
                                </InputAdornment> */}
                                <SearchIcon fontSize='medium' sx={{ color: theme.palette.primary.main, mr: "5px" }} />
                            </>
                        ),
                        endAdornment: endAdornment ? (
                            endAdornment
                        ) : (
                            <InputAdornment position="end" sx={{ opacity: searchTerm ? 1 : 0 }}>
                                <IconButton style={{ padding: 2 }} onClick={handleClear}>
                                    <ClearIcon fontSize="small" color="disabled" />
                                </IconButton>
                            </InputAdornment>
                        ),
                        style: { borderRadius: 4 }
                    }}
                    variant={variant || "outlined"}
                    fullWidth={fullWidth}
                    sx={{
                        width: { xs: '100%', sm: '300px', },
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                        },
                    }}
                />
            </Tooltip>
        </Box>
    );
};

export default CommonSearchField;


{/* <TextField
placeholder="Search"
variant="outlined"
size="small"
InputProps={{
    startAdornment: (
        <InputAdornment position="start">
            <img src={"images/SearchIcon.svg"} width="20px" height="20px" />
        </InputAdornment>
    ),
    style: { borderRadius: 4 }
}}
sx={{
    width: { xs: '100%', sm: '300px' },
    '& .MuiOutlinedInput-root': {
        borderRadius: 2,
    },
}}
/> */}
